
import { WorldCountry } from '../types';
import { polandData } from './poland';

export const finalEuropeCountries3: WorldCountry[] = [
  {
    name: 'Austria',
    slug: 'austria',
    code: 'AT',
    population: 9006398,
    topCities: [
      { name: 'Vienna', slug: 'vienna', population: 1911191 },
      { name: 'Graz', slug: 'graz', population: 331778 },
      { name: 'Linz', slug: 'linz', population: 206604 },
      { name: 'Salzburg', slug: 'salzburg', population: 155031 },
      { name: 'Innsbruck', slug: 'innsbruck', population: 132493 },
      { name: 'Klagenfurt', slug: 'klagenfurt', population: 101403 },
      { name: 'Villach', slug: 'villach', population: 63244 },
      { name: 'Wels', slug: 'wels', population: 62946 },
      { name: 'Sankt Pölten', slug: 'sankt-polten', population: 55419 },
      { name: 'Dornbirn', slug: 'dornbirn', population: 49845 }
    ]
  },
  {
    name: 'Belarus',
    slug: 'belarus',
    code: 'BY',
    population: 9449323,
    topCities: [
      { name: 'Minsk', slug: 'minsk', population: 1996553 },
      { name: 'Gomel', slug: 'gomel', population: 535229 },
      { name: 'Mogilev', slug: 'mogilev', population: 383313 },
      { name: 'Vitebsk', slug: 'vitebsk', population: 378459 },
      { name: 'Grodno', slug: 'grodno', population: 373547 },
      { name: 'Brest', slug: 'brest-belarus', population: 344470 },
      { name: 'Babruysk', slug: 'babruysk', population: 217546 },
      { name: 'Baranovichi', slug: 'baranovichi', population: 179073 },
      { name: 'Barysaw', slug: 'barysaw', population: 143919 },
      { name: 'Pinsk', slug: 'pinsk', population: 138202 }
    ]
  },
  {
    name: 'Belgium',
    slug: 'belgium',
    code: 'BE',
    population: 11589623,
    topCities: [
      { name: 'Brussels', slug: 'brussels', population: 1208542 },
      { name: 'Antwerp', slug: 'antwerp', population: 529247 },
      { name: 'Ghent', slug: 'ghent', population: 263614 },
      { name: 'Charleroi', slug: 'charleroi', population: 202598 },
      { name: 'Liège', slug: 'liege', population: 197355 },
      { name: 'Bruges', slug: 'bruges', population: 118656 },
      { name: 'Namur', slug: 'namur', population: 111300 },
      { name: 'Leuven', slug: 'leuven', population: 101808 },
      { name: 'Mons', slug: 'mons', population: 95259 },
      { name: 'Aalst', slug: 'aalst', population: 87598 }
    ]
  },
  {
    name: 'Bosnia and Herzegovina',
    slug: 'bosnia-herzegovina',
    code: 'BA',
    population: 3280819,
    topCities: [
      { name: 'Sarajevo', slug: 'sarajevo', population: 395133 },
      { name: 'Banja Luka', slug: 'banja-luka', population: 185042 },
      { name: 'Tuzla', slug: 'tuzla', population: 110979 },
      { name: 'Zenica', slug: 'zenica', population: 110663 },
      { name: 'Mostar', slug: 'mostar', population: 105797 },
      { name: 'Bijeljina', slug: 'bijeljina', population: 107715 },
      { name: 'Brčko', slug: 'brcko', population: 93028 },
      { name: 'Prijedor', slug: 'prijedor', population: 89397 },
      { name: 'Trebinje', slug: 'trebinje', population: 31433 },
      { name: 'Cazin', slug: 'cazin', population: 66149 }
    ]
  },
  {
    name: 'Bulgaria',
    slug: 'bulgaria',
    code: 'BG',
    population: 6948445,
    topCities: [
      { name: 'Sofia', slug: 'sofia', population: 1431876 },
      { name: 'Plovdiv', slug: 'plovdiv', population: 346893 },
      { name: 'Varna', slug: 'varna', population: 335949 },
      { name: 'Burgas', slug: 'burgas', population: 203017 },
      { name: 'Ruse', slug: 'ruse', population: 142902 },
      { name: 'Stara Zagora', slug: 'stara-zagora', population: 138272 },
      { name: 'Pleven', slug: 'pleven', population: 99628 },
      { name: 'Sliven', slug: 'sliven', population: 91620 },
      { name: 'Dobrich', slug: 'dobrich', population: 87370 },
      { name: 'Shumen', slug: 'shumen', population: 80855 }
    ]
  },
  {
    name: 'Croatia',
    slug: 'croatia',
    code: 'HR',
    population: 3888529,
    topCities: [
      { name: 'Zagreb', slug: 'zagreb', population: 767131 },
      { name: 'Split', slug: 'split', population: 161312 },
      { name: 'Rijeka', slug: 'rijeka', population: 108622 },
      { name: 'Osijek', slug: 'osijek', population: 96848 },
      { name: 'Zadar', slug: 'zadar', population: 70829 },
      { name: 'Pula', slug: 'pula', population: 52220 },
      { name: 'Slavonski Brod', slug: 'slavonski-brod', population: 53531 },
      { name: 'Karlovac', slug: 'karlovac', population: 47205 },
      { name: 'Varaždin', slug: 'varazdin', population: 38839 },
      { name: 'Šibenik', slug: 'sibenik', population: 34302 }
    ]
  },
  // Continue with remaining countries inline...
  polandData
];
